import { render, staticRenderFns } from "./u-crumb-item.vue?vue&type=template&id=24a745ad&scoped=true&"
import script from "./u-crumb-item.vue?vue&type=script&lang=js&"
export * from "./u-crumb-item.vue?vue&type=script&lang=js&"
import style0 from "./u-crumb-item.vue?vue&type=style&index=0&id=24a745ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a745ad",
  null
  
)

export default component.exports